import { Trans } from "@lingui/macro";
import { Link } from "@winamp/ui/components/Link/Link.js";
import { getDialogRoute } from "../../modules/route-dialogs/RouteDialogsContext";

export function SpotifyImportWarningMessages({
  isBlackListed,
  isVerifiedKYC,
}: {
  isBlackListed: boolean | undefined;
  isVerifiedKYC: boolean | undefined;
}) {
  return (
    <>
      {(isBlackListed || !isVerifiedKYC) && (
        <div className="mt-4 text-sm text-center font-medium">
          {isBlackListed ? (
            <p className="text-warning">
              <Trans>
                Please{" "}
                <Link
                  target="_blank"
                  to="https://support.winamp.com/your-account"
                  className="underline hover:no-underline font-semibold"
                >
                  contact support
                </Link>{" "}
                so we can enable platform access for your account.
              </Trans>
            </p>
          ) : !isVerifiedKYC ? (
            <p className="text-info">
              <Trans>
                Make sure to{" "}
                <Link
                  to={getDialogRoute("kyc.start")}
                  className="underline hover:no-underline font-semibold"
                >
                  verify your identity
                </Link>{" "}
                so we can automatically import your catalog from your Spotify
                account.
              </Trans>
            </p>
          ) : null}
        </div>
      )}
    </>
  );
}
